import {http} from 'metro-core';

export const loadImageBlob = async url => {
    const response = await http.axios.get(url, {
        responseType: 'blob'
    });
    return response.data;
};
